import { put, takeLatest } from 'redux-saga/effects';

import { axiosCall } from '@utils';
import API from '@sm/api';
import { setNotificationMsgAction } from 'seller/store/actions';
import {
  CREATE_ALERT,
  DELETE_ALERT,
  PATCH_ALERT,
  PULL_ALERTS,
  PULL_SCOPE_ITEMS,
  SEND_ALERT_TEST_NOTIFICATION,
  setAlertsAction,
  setAlertsLoadingAction
} from './action';

function* pullAlertsSaga() {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.get(API.notifications.alerts.list);
    yield put(setAlertsAction(data));
  } catch (error) {
    yield put(setAlertsAction([]));
    yield put(
      setNotificationMsgAction(
        'Failed to load alerts. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    yield put(setAlertsLoadingAction(false));
  }
}
function* createAlertsSaga({ payload, callback }) {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.post(API.notifications.alerts.list, payload);
    yield put(setAlertsAction(data));
  } catch (error) {
    yield put(setAlertsAction([]));
    yield put(
      setNotificationMsgAction(
        'Failed to create alert. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    callback();
    yield put(setAlertsLoadingAction(false));
  }
}
function* patchAlertsSaga({ payload, callback }) {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.patch(API.notifications.alerts.list, payload);
    yield put(setAlertsAction(data));
  } catch (error) {
    yield put(setAlertsAction([]));
    yield put(
      setNotificationMsgAction(
        'Failed to update alert. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    callback();
    yield put(setAlertsLoadingAction(false));
  }
}
function* deleteAlertsSaga({ payload }) {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.delete(API.notifications.alerts.list, { data: payload });
    yield put(setAlertsAction(data));
  } catch (error) {
    yield put(setAlertsAction([]));
    yield put(
      setNotificationMsgAction(
        'Failed to delete alert. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    yield put(setAlertsLoadingAction(false));
  }
}
function* pullScopeItemsSaga({ payload, callback }) {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.post(API.notifications.alerts.scope_items, payload);
    callback(data);
  } catch (error) {
    callback({});
    yield put(
      setNotificationMsgAction(
        'Failed to pull alert details. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    yield put(setAlertsLoadingAction(false));
  }
}
function* SendAlertTestNotificationSaga({ payload }) {
  try {
    yield put(setAlertsLoadingAction(true));
    const { data } = yield axiosCall.post(API.notifications.alerts.send_test_notification, {
      alert_id: payload.alert_id,
      to: payload.date,
      days_to_analyze: 1
    });
    const success = data.notifications_sent;
    yield put(
      setNotificationMsgAction(
        success
          ? 'Test notification has been sent successfully'
          : 'Test notification not sent - alert conditions were not met',
        success ? 'success' : 'error'
      )
    );
  } catch (error) {
    yield put(setNotificationMsgAction('Failed to send test notification.'));
  } finally {
    yield put(setAlertsLoadingAction(false));
  }
}

export function* alertsSagaWatcher() {
  yield takeLatest(PULL_ALERTS, pullAlertsSaga);
  yield takeLatest(CREATE_ALERT, createAlertsSaga);
  yield takeLatest(PATCH_ALERT, patchAlertsSaga);
  yield takeLatest(DELETE_ALERT, deleteAlertsSaga);
  yield takeLatest(PULL_SCOPE_ITEMS, pullScopeItemsSaga);
  yield takeLatest(SEND_ALERT_TEST_NOTIFICATION, SendAlertTestNotificationSaga);
}
